import { useRef, useState } from "react";
import { Upload, ImageIcon } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const ImageUpload = ({ value, onChange, testId = "image-upload", hint = "blank = brand image" }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Photo uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex gap-3 items-start" data-testid={testId}>
      <div className="w-24 h-24 rounded-xl border border-slate-200 bg-slate-50 overflow-hidden flex items-center justify-center shrink-0">
        {value ? <img src={value} alt="" className="w-full h-full object-cover" data-testid={`${testId}-preview`} /> : <ImageIcon className="text-slate-300" />}
      </div>
      <div className="flex-1 space-y-2">
        <input className="sr-input py-2 text-xs" value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={`Image URL (${hint})`} data-testid={`${testId}-url`} />
        <div className="flex gap-2">
          <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`${testId}-file`} />
          <button type="button" disabled={busy} onClick={() => ref.current?.click()} className="sr-btn-outline !py-1.5 !px-3 text-xs disabled:opacity-60" data-testid={`${testId}-button`}>
            <Upload size={13} /> {busy ? "Uploading…" : "Upload photo"}
          </button>
          {value && <button type="button" onClick={() => onChange("")} className="text-xs text-slate-500 hover:text-[#E63946]" data-testid={`${testId}-clear`}>Remove</button>}
        </div>
        <p className="text-[11px] text-slate-400">JPG, PNG, WEBP or GIF · max 8 MB</p>
      </div>
    </div>
  );
};
